import React, { useState } from "react";
import { AssistantRounded } from "@mui/icons-material";
import { IconButton, Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { GradientIconAccent } from "../../../components/GradientIcon";
import QueryBox from "../AI_Search/components/QueryBox/QueryBox";
import { setQuerySuccess } from "../../../core/events/queryEvents";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { createSession } from "../../../core/repo/sessionRepo";
import { AI_SEARCH_URL } from "../../../utils/routes";
import Loader from "../../../components/Loader";
import { usePostHog } from "posthog-js/react";
import {
  CREATE_NEW_SESSION_SUCCESS,
  CREATE_NEW_SESSION_FAILURE,
} from "../../../utils/posthogEvents";
import { useThemeSettings } from "../../../theme/ThemeSettingsProvider";

const useStyles = makeStyles()((theme) => ({
  iconButton: {
    background:
      "linear-gradient(291deg, rgba(239, 143, 226, 0.12) 1.52%, rgba(176, 143, 239, 0.12) 43.76%, rgba(154, 143, 239, 0.12) 86.01%)",
    "&:hover": {
      background:
        "linear-gradient(291deg, rgba(239, 143, 226, 0.12) 1.52%, rgba(176, 143, 239, 0.12) 43.76%, rgba(154, 143, 239, 0.12) 86.01%)",
    },
  },
  gradientText: {
    background: theme.palette.accentGradient,
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

function Content() {
  const { mode } = useThemeSettings();
  const isDarkMode = mode === "dark";
  const posthog = usePostHog();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { selectedDomain } = useSelector((state) => state.domain);
  const [isLoading, setIsLoading] = useState(false);

  const handleQuery = async (query) => {
    try {
      setIsLoading(true);
      const response = await dispatch(createSession(selectedDomain.id));
      dispatch(setQuerySuccess(query));
      history.push(`${AI_SEARCH_URL}/${response.id}`);
      posthog.capture(CREATE_NEW_SESSION_SUCCESS);
    } catch (error) {
      console.error(error);
      posthog.capture(CREATE_NEW_SESSION_FAILURE);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading ? (
    <Loader />
  ) : (
    <Box
      p={3}
      mb={11}
      flexGrow={1}
      overflow={"auto"}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}>
      <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
        <IconButton className={classes.iconButton}>
          {isDarkMode ? (
            <AssistantRounded
              sx={{
                fontSize: 26,
                color: (theme) => theme.palette.primary.main,
              }}
            />
          ) : (
            <GradientIconAccent Icon={AssistantRounded} sx={{ fontSize: 26 }} />
          )}
        </IconButton>
        <Box mb={2} />
        <Typography variant="h6">
          Ask me anything about {selectedDomain.domain}
        </Typography>
        <Box mb={6} />
        <Box maxWidth={768} width={"100%"}>
          <QueryBox handleQuery={handleQuery} isNewSession={true} />
        </Box>
      </Box>
    </Box>
  );
}

export default Content;
